/* ConnectedUsersModal — chi è collegato adesso.
   Il foglio, la testata e la card sul desktop arrivano da `play-online-modal`
   (PlayModals.css): qui c'è solo ciò che è di questa lista.
   Mobile-first: tutto pensato a 360px e allentato salendo. */

.connected-users-modal.dashboard-modal {
  max-width: 520px;
}

.connected-users-modal .play-online-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

/* ─── Il totale, accanto al titolo ───────────────────────────────────────
   Badge suo e non `.player-count`: quella classe vive in OnlinePlayersList.css
   ed è della lista. Stessa veste, per non far sembrare due cose diverse due
   numeri che sono lo stesso. */
.connected-users-modal .play-online-head h2 {
  display: flex;
  align-items: center;
  gap: 8px;
  /* Cresce lui, così il conto e la X si stringono nell'angolo destro: la
     testata è `space-between` (PlayModals.css) e con TRE figli — titolo, conto,
     X — il conto resterebbe a mezz'aria in mezzo alla riga. Nessun
     `margin-left: auto` da nessuna parte qui: è questa riga a reggere
     l'allineamento. Da solo (≤768px) non cambia niente, i figli sono due. */
  flex: 1 1 auto;
  min-width: 0;
}

.connected-head-count {
  /* A 360px si stringe il titolo, mai il numero. */
  flex: 0 0 auto;
  padding: 2px 10px;
  border-radius: var(--radius-lg);
  background-color: var(--color-primary);
  color: var(--color-on-accent);
  font-size: 0.8rem;
  font-weight: 600;
}

/* ─── Il conto alla rovescia, in testata ─────────────────────────────────
   Da affiancati questa metà di riga portava il solo titolo, mentre la lista
   apriva una testata sua — titolino, conto, chip dei punteggi — che ripeteva il
   titolo qui sopra. Ora la lista disegna il conto QUI, con un portale, nella
   veste compatta: icona più secondi. Sta a sinistra della X, che da affiancati
   è qui — è questa la metà destra della card, cioè il suo angolo.

   Compatta perché la frase intera non ci sta. A 769px la mezza colonna offre
   ~327px di contenuto (il conto è misurato in PlayOverlay.css): l'icona a 13 più
   «30 s» fanno ~45px, la X 44, e coi due gap da 10 al titolo restano ~218 —
   mentre il titolo più lungo delle otto lingue, `Jugadores en línea`, col badge
   ne vuole ~184. Trentaquattro pixel di margine, non di più: la frase intera (in
   tedesco ~132px) qui strizzerebbe il titolo.
   `nowrap` e `flex: 0 0 auto`: è l'unico pezzo della riga che cambia una volta
   al secondo, e non deve essere lui a cedere. Non è interattivo, quindi il
   pavimento di 44x44 non lo riguarda. */
.connected-head-conto {
  display: inline-flex;
  flex: 0 0 auto;
}
.connected-head-conto .reload-countdown {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

/* La rete di sicurezza del titolo: cede TRONCANDO, non andando a capo. Una
   seconda riga qui dentro renderebbe questa testata più alta di quella di
   «Gioca» che le sta a fianco, e il filo che le attraversa — una card sola, una
   riga sola — si sfalserebbe (vedi `.coppia-gioca .play-online-head` in
   PlayOverlay.css). Nelle otto lingue non si attiva: è una rete, non una misura. */
.connected-users-modal .play-online-head .connected-head-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ─── Ospite che prova a sfidare ─────────────────────────────────────────
   Non un errore: un invito. Perciò tono neutro-caldo, e una via d'uscita sola:
   l'«Accedi» della navbar — che però sotto i 767px questo foglio copre, quindi
   qui ne spunta la maniglia. Un bottone, non due: «Registrati» sta dentro il
   modale d'accesso. */
.guest-challenge-notice {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 14px;
  background: rgba(212, 164, 55, 0.12);
  border: 1px solid rgba(212, 164, 55, 0.3);
  font-size: 0.88rem;
}
.guest-challenge-notice p { margin: 0; }

/* Figlio diretto di una colonna flex: a tutta larghezza per default, come
   vuole una CTA su 360px. */
.guest-notice-login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: var(--touch-target-min);
  padding: 8px 12px;
  border: 1px solid var(--color-hairline-strong);
  border-radius: 10px;
  background: var(--color-frost-solid);
  color: var(--color-text);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

/* ─── «Siediti al suo tavolo» oppure «sfidalo a modo tuo» ────────────────
   Progettato a 360px: titolo, pillole che vanno a capo, e poi bottoni in
   colonna a tutta larghezza, 44px di altezza minima. Niente `.modal-actions`
   qui — sotto i 767px PlayModals.css la rende `sticky; bottom: 0`, e i bottoni
   si staccherebbero dal riquadro per incollarsi in fondo al foglio. */
.table-choice {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 14px;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  font-size: 0.88rem;
}

.table-choice-title {
  margin: 0;
  font-weight: 600;
}

.table-choice-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.table-choice-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 999px;
  background: var(--color-veil);
  color: var(--color-text-secondary);
  font-size: 0.78rem;
  white-space: nowrap;
}

.table-choice-note,
.table-choice-barred,
.table-choice-error {
  margin: 0;
  font-size: 0.8rem;
}

.table-choice-note { color: var(--color-text-secondary); }
.table-choice-barred { color: var(--color-warning-text); }
.table-choice-error { color: var(--color-error-text); }

/* Figli diretti di una colonna flex: a tutta larghezza, come vuole una CTA a
   360px. Il bersaglio minimo è il token, non un valore scritto a mano. */
.table-choice-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: var(--touch-target-min);
  padding: 8px 12px;
  border: 1px solid var(--color-hairline-strong);
  border-radius: 10px;
  background: var(--color-frost-solid);
  color: var(--color-text);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.table-choice-action.is-sit {
  border-color: transparent;
  background: var(--color-primary);
  color: var(--color-on-accent);
}

.table-choice-action.is-cancel {
  border-color: transparent;
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.table-choice-action:disabled {
  opacity: 0.6;
  cursor: default;
}

/* ─── La lista a piena altezza ───────────────────────────────────────────
   `.players-list` porta un `max-height: 180px` che nasce nella scatoletta di
   Sfida diretta. Qui il foglio è già l'unica area di scorrimento (a ≤767px
   `.play-online-body`, sul desktop la card a 90vh), quindi quel tetto mostrava
   tre righe su una schermata vuota, con una barra di scorrimento da 5px. Il cap
   resta dov'è per Sfida diretta: qui lo si toglie e basta. */
.connected-users-modal .players-list {
  max-height: none;
  overflow: visible;
}
